import { Card, Highlight } from "@mantine/core"
import {
  PaginatedListRequest,
  InfinitScrollingList,
} from "../../../-components/infinit-scrolling-list"
import { useTranslation } from "react-i18next"
import {
  PaginatedProductionDtoListRequest,
  ProductionDto,
} from "../../../../../@client/Theasoft_ApiServer_Productions"
import { getFormattedDate } from "../../../../../utils/get-formatted-date"
import { ExclusiveProperties } from "../../../../../utils/exclusive-properties"

interface Props {
  partialInput: ExclusiveProperties<
    PaginatedProductionDtoListRequest,
    PaginatedListRequest
  >
  onClickItem: (production: ProductionDto) => void
}

export function ProductionCardList({ partialInput, onClickItem }: Props) {
  const { t } = useTranslation("app_server")
  return (
    <InfinitScrollingList
      url="/api/Production/GetList"
      partialInput={partialInput}
      renderItem={(item) => (
        <Card
          key={item.id}
          shadow="xs"
          style={{ cursor: "pointer" }}
          onClick={() => onClickItem(item)}
        >
          <Highlight
            fw={500}
            children={item.title ?? ""}
            highlight={partialInput.searchString}
          />
          <Highlight
            children={item.identifier ?? ""}
            highlight={partialInput.searchString}
          />
          <Highlight
            children={
              item.premiere
                ? t("Premiere") + ": " + getFormattedDate(item.premiere)
                : ""
            }
            highlight={""}
          />
        </Card>
      )}
    />
  )
}
